module.exports = __webpack_public_path__ + "static/img/EG@3x.906698ee.jpg";